var _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStationGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 97.664,
    width: 16,
    height: 320.96
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0",
    x: 104.672,
    y: 250.208,
    width: 302.656,
    height: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    x: 104.672,
    y: 250.208,
    width: 302.656,
    height: 16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.528,
    y: 403.68,
    width: 309.824,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.528,
    y: 92.272,
    width: 309.824,
    height: 16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 54.784,
    cy: 258.24,
    r: 54.784
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.216,
    cy: 258.24,
    r: 54.784
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.784,
    cy: 411.728,
    r: 54.784
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.216,
    cy: 411.728,
    r: 54.784
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.784,
    cy: 100.272,
    r: 54.784
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 457.216,
    cy: 100.272,
    r: 54.784
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationGroup);
export default __webpack_public_path__ + "static/media/station-group.da0e4632.svg";
export { ForwardRef as ReactComponent };